<template>
  <div>
    <h1>{{ $t("login.passwordChangeForm") }}</h1>
    <v-form v-model="valid" @submit.prevent="passwordChange" ref="form">
      <v-text-field :label="$t('login.company')" :rules="companyRules" @keyup.enter="passwordChange" required name="company" v-model="company" />
      <v-text-field :label="$t('login.login')" :rules="loginRules" @keyup.enter="passwordChange" required name="login" v-model="login" />
      <v-text-field
        name="password"
        :label="$t('login.password')"
        :rules="oldPasswordRules"
        type="password"
        @keyup.enter="passwordChange"
        required
        v-model="oldPassword"
      />
      <v-text-field :label="$t('login.newPassword')" password type="password" v-model="newPassword" :rules="newPasswordRules" required />
      <v-text-field :label="$t('login.newPasswordRepeat')" type="password" password v-model="newPasswordRepeat" :rules="newRepeatPasswordRules" required />
      <v-btn class="success" @click="passwordChange">{{ $t("global.save") }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { passwordRules } from "../models/user.js";
import _ from "lodash";

export default {
  name: "PasswordExpired",
  data: () => ({
    valid: false,
    company: "",
    login: "",
    oldPassword: "",
    newPassword: "",
    newPasswordRepeat: "",
    passwordError: null,
    passwordValidated: false
  }),
  methods: {
    passwordChange() {
      if (this.$refs.form.validate() && this.passwordValidated === true && this.passwordError === null) {
        let form = {
          company: this.company,
          username: this.login,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        };
        this.axios
          .post("/auth/password-expired", form)
          .then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            this.$router.push("/login");
          })
          .catch(() => {
            this.$store.dispatch("alertDialog", {
              content: this.$t("login.loginFailedDialog.content"),
              title: this.$t("login.loginFailedDialog.title")
            });
          });
      }
    },
    validatePassword: _.throttle(
      function() {
        this.passwordValidated = false;
        this.axios.post("auth/validate-password-complexity", { password: this.newPassword, company: this.company }).then(resp => {
          this.passwordError = null;
          if (typeof resp.data.status !== "undefined" && resp.data.status === "OK") {
            this.passwordValidated = true;
          } else if (typeof resp.data.error !== "undefined") {
            this.passwordError = resp.data.error;
          }
        });
      },
      1000,
      { leading: false }
    )
  },
  watch: {
    auth_status(val) {
      if (val === "logged") {
        if (typeof this.$route.params.address !== "undefined") {
          this.$router.replace("/login");
        }
      }
    },
    company() {
      this.validatePassword();
    },
    newPassword() {
      this.validatePassword();
    }
  },
  computed: {
    passwordErrorMessage() {
      if (this.passwordError === null) {
        return true;
      }
      return this.$t("user.validation." + this.passwordError);
    },
    user_name: function() {
      if (this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.name;
      }
      return null;
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    auth_status: function() {
      return this.$store.getters["authStatus"];
    },
    companyRules() {
      if (!this.company) return [this.$t("global.error.required")];
      return [];
    },
    loginRules() {
      if (!this.login) return [this.$t("global.error.required")];
      return [];
    },
    oldPasswordRules() {
      if (!this.oldPassword) return [this.$t("global.error.required")];
      return [];
    },
    newPasswordRules() {
      // eslint-disable-next-line no-extra-boolean-cast
      //if (!this.newPassword) return [this.$t("user.validation.passwordIsRequired")];
      //if (!this.passwordRegexp.test(this.newPassword)) return [this.$t("user.validation.passwordLength")];
      if (this.newPassword === this.oldPassword) return [this.$t("login.passwordMustBeChanged")];
      if (this.passwordErrorMessage !== true) {
        return [this.passwordErrorMessage];
      }
      return passwordRules;
    },
    newRepeatPasswordRules() {
      if (this.newPassword !== this.newPasswordRepeat) return [this.$t("user.validation.repeatPassword")];
      return [];
    }
  }
};
</script>

<style scoped></style>
